export enum InternallyChoice
{
    Internally = 'Internally'
}
